import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ff10161"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-auto container position-absolute" }

import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { PATH } from '@/constants'
import userService from '@/services/auth.service'
import joinCommunityService from '@/services/joinCommunity.service'
import { getCookie, removeCookie } from '@/utils'
import ErrorMessage from '@/components/error-message'
import { translate } from '@/languages/i18n'
import { ERROR_INVALID_PARAMS, ERROR_EXPIRED, ERROR_PARTICIPATED, INVALID_URL_ERROR } from '@/constants/messageCode'
import { USER_STORE } from '@/store/constants'
import { useStore } from 'vuex'

type InvitedCommunity = {
  admin: boolean
  community_id: string
  corporation_name: string
  community_name: string
  invited_code_employee: string
  department_name: string
  email: string
  expiration_date: string
}


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

const invitedCodeNotFound = ref<boolean>(false)
const expiredUrl = ref<boolean>(false)
const invalidUrl = ref<boolean>(false)
const userParticipant = ref<boolean>(false)

const invitedCommunity = ref<InvitedCommunity>({
  admin: true,
  community_id: '',
  corporation_name: '',
  community_name: '',
  invited_code_employee: '',
  department_name: '',
  email: '',
  expiration_date: '',
})

onMounted(async () => {
  document.cookie = `invited_code_employee=${route.params?.key}; path=/`
  const path = PATH[`${route.path.split('/')[1]}`]

  if (route.params?.key) {
    try {
      const invitedCommunityRes = await userService.getInvitedEmployeeApi(route.params?.key)

      if (invitedCommunityRes?.response?.status === 400) {
        if (invitedCommunityRes?.response?.data?.data[0]?.message_code === ERROR_INVALID_PARAMS) invitedCodeNotFound.value = true
        if (invitedCommunityRes?.response?.data?.data[0]?.message_code === ERROR_EXPIRED) expiredUrl.value = true
        if (invitedCommunityRes?.response?.data?.data[0]?.message_code === ERROR_PARTICIPATED) userParticipant.value = true
        if (invitedCommunityRes?.response?.data?.data[0]?.message_code === INVALID_URL_ERROR) invalidUrl.value = true
      }

      invitedCommunity.value = invitedCommunityRes?.data?.data
      if (invitedCommunityRes?.data?.data?.community_id) {
        const getRegistrationRes = await joinCommunityService.getRegistrationTimeApi(invitedCommunityRes?.data?.data?.community_id, route.params?.key)
        if (getCookie(path.header) && getCookie(path?.pathName)) {
          removeCookie(path.header)
          removeCookie(path?.pathName)
          removeCookie(`__Secure-${path?.path}_unique_user_id`)
          removeCookie(`${path?.header}-one-time`)
        }
        await store.dispatch(USER_STORE.ACTIONS.SET_MAIL_INVITE, invitedCommunity.value?.email)
        if (getRegistrationRes?.status === 200) {
          removeCookie(`${path?.header}-one-time`)
          if (getRegistrationRes?.data?.data?.first_time) {
            router.push('/community/join_users')
          } else {
            router.push(`/community/users/login?redirect=/community/join_users`)
          }
        } else if (getRegistrationRes?.response?.status !== 403) {
          router.push(`/confirm_error?message_code=${getRegistrationRes?.response?.data?.data[0]?.message_code}`)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (invitedCodeNotFound.value)
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 0,
          title: _unref(translate)('invitedCodeNotFound')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (expiredUrl.value)
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 1,
          title: _unref(translate)('expiredUrl')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (userParticipant.value)
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 2,
          title: _unref(translate)('errorParticipated')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (invalidUrl.value)
      ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
          key: 3,
          title: _unref(translate)('INVALID_URL_ERROR')
        }, null, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})